<template>
  <div class="comentary-box">
    <div class="comentary-box__img-profile">
      <img
        :src="currentUser.ImageUrl ? currentUser.ImageUrl : renderAlterAvatar"
        class="avatar"
        alt="avatar"
      />
    </div>
    <div class="comentary-box__content">
      <div class="_25-w">
        <form class="a" role="presentation">
          <div class="b" data-visualcompletion="ignore">
            <div class="c">
              <div class="d1" v-show="show_placeholder">
                <div
                  class="d1_e"
                  id="placeholder-2t7fe"
                  style="white-space: pre-wrap"
                >
                  Escribe un comentario...
                </div>
              </div>
              <div class="d2">
                <div
                  aria-label="Comentario en la publicación"
                  class="d2_e"
                  contenteditable="true"
                  role="textbox"
                  spellcheck="true"
                  style="
                    outline: none;
                    user-select: text;
                    white-space: pre-wrap;
                    overflow-wrap: break-word;
                  "
                  @keypress="captureMessage"
                  @focusout="update"
                  ref="box_message"
                  @click="handleClick"
                >
                  <div data-contents="true">
                    <div
                      class=""
                      data-block="true"
                      data-editor="2t7fe"
                      data-offset-key="bhtg7-0-0"
                    >
                      <div data-offset-key="bhtg7-0-0" class="d2_f">
                        <span data-offset-key="bhtg7-0-0">
                          <br data-text="true" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  name: "ComentaryBox",
  props: ["message"],
  data() {
    return {
      comentary: "",
      show_placeholder: true,
      my_focus: false
    };
  },
  methods: {
    ...mapActions({ crate_comment: "comment/create" }),
    ...mapMutations({ pushComment: "message/pushCommentItem" }),
    captureMessage(e) {
      if (this.show_placeholder === true) {
        this.show_placeholder = false;
      } else {
        if (e.target.textContent === null) {
          this.show_placeholder = true;
        }
      }

      if (e.charCode === 13) {
        // Enter press, submit comentary
        e.preventDefault();

        this.crate_comment({
          comment: {
            Content: e.target.textContent,
            ObjectId: this.message.Id,
            ObjectTable: "Messages",
            CreatedByUserId: this.currentUser.UserID,
            UpdatedByUserId: this.currentUser.UserID
          }
        }).then((resp) => {
          this.pushComment({
            message_id: this.message.Id,
            comment: resp.data
          });
        });

        e.target.textContent = "";
        this.comentary = "";
      } else {
        this.comentary = e.target.textContent;
      }
    },
    update(e) {
      if (e.target.textContent === null) {
        this.show_placeholder = true;
      }
      this.comentary = e.target.textContent;
    },
    setFocusMessageBox() {
      this.$refs.box_message.focus();
    },
    handleClick() {
      this.setFocusMessageBox();
    }
  },
  watch: {
    comentary(e) {
      if (e === "") {
        this.show_placeholder = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  border-radius: 50%;
  width: 35px;
  height: 35px;
  border: 1px solid #fff;
  margin-left: 20px;
  box-sizing: border-box;
  display: block;
  cursor: pointer;
  box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.5s;

  &:hover {
    box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08),
      0px 2px 7px 0 rgba(0, 0, 0, 0.08);
  }
}

.comentary-box {
  font-family: inherit;
  display: flex;
  padding-right: 16px;
  padding-left: 16px;
  padding-bottom: 4px;
  padding-top: 4px;
  flex-direction: row;
  outline: none;

  .comentary-box__img-profile {
    font-family: inherit;
    border-radius: 50%;
    margin-top: 2px;
    margin-right: 6px;
    align-content: flex-start;
    position: relative;
    display: block;
  }

  .comentary-box__content {
    font-family: inherit;
    overflow-y: hidden;
    overflow-x: inherit;
    flex: 1;

    ._25-w {
      flex-grow: 1;

      .a {
        background-color: #edf1f3;
        border: 0;
        border-radius: 20px;
        cursor: text;
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: flex-end;

        .b {
          color: black;
          font-size: 15px;
          font-weight: 400;
          line-height: 17px;
          padding: 10px 12px 9px 12px;
          cursor: text;
          flex: 1 1 auto;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          border: 0;

          .c {
            z-index: 0;
            position: relative;
            height: inherit;
            text-align: inherit;

            .d1 {
              color: black;
              width: 100%;
              position: absolute;
              z-index: 1;

              .d1_e {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap !important;
              }
            }

            .d2 {
              background-color: rgba(255, 255, 255, 0);
              border-left: 0.1px solid transparent;
              position: relative;
              z-index: 1;

              .d2_e {
                height: inherit;
                text-align: initial;
                background-color: transparent;
                border: 0;
                resize: none;
                word-break: break-word;

                .d2_f {
                  position: relative;
                  white-space: pre-wrap;
                  direction: ltr;
                  text-align: left;
                }
              }
            }

            .d2[contenteditable="true"] {
              -webkit-user-modify: read-write-plaintext-only;
            }
          }
        }
      }
    }
  }
}
</style>
